// Open the sale dialog
function openSaleDialog() {
  const dialog = document.querySelector('sale-dialog');
  if (dialog) {
    dialog.classList.add('active');
    document.body.classList.add('sale-dialog-open');

    // Focus close button for accessibility
    const closeButton = dialog.querySelector('.sale-dialog__close');
    if (closeButton) closeButton.focus();
  }
}

// Close the sale dialog
function closeSaleDialog() {
  const dialog = document.querySelector('sale-dialog');
  if (dialog) {
    dialog.classList.remove('active');
    document.body.classList.remove('sale-dialog-open');
  }
}

// Function to set up event listeners
function setupSaleDialogListeners() {
  // Trigger button clicks - ALWAYS set up, even if dialog doesn't exist yet
  // Use capture phase to ensure we catch the event early
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-sale-dialog-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      openSaleDialog();
    }
  }, true); // Use capture phase

  // Dialog-specific listeners - only set up if dialog exists
  const dialog = document.querySelector('sale-dialog');
  if (!dialog) {
    return;
  }

  // Close button click
  const closeButton = dialog.querySelector('.sale-dialog__close');
  if (closeButton) {
    closeButton.addEventListener('click', closeSaleDialog);
  }

  // Click overlay to close
  const overlay = dialog.querySelector('.sale-dialog__overlay');
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        closeSaleDialog();
      }
    });
  }

  // Escape key to close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && dialog.classList.contains('active')) {
      closeSaleDialog();
    }
  });
}

// Set up event listeners when DOM is ready
if (document.readyState === 'loading') {
  // DOM hasn't finished loading yet, wait for DOMContentLoaded
  document.addEventListener('DOMContentLoaded', setupSaleDialogListeners);
} else {
  // DOM is already loaded, set up listeners immediately
  setupSaleDialogListeners();
}

// Keep the custom element registration for the HTML tag
class SaleDialog extends HTMLElement {}
customElements.define('sale-dialog', SaleDialog);
